import { ZoneVariant } from "../../../Domain/Types/FloorPlan/ZoneVariant.type";
import { colorPerType } from "./colorPerType.function";

export function resolveZonePolygonFillColor({
  zoneType,
  variant,
  isSelected,
  disabled,
  selectedFillColor,
  isReferenceHighlighted,
  referenceFillColor
}: {
  zoneType: number;
  variant: ZoneVariant | undefined;
  isSelected: boolean;
  disabled?: boolean;
  selectedFillColor?: number;
  isReferenceHighlighted?: boolean;
  referenceFillColor?: number;
}): number {
  if (isSelected && selectedFillColor != null) {
    return selectedFillColor;
  }
  if (isReferenceHighlighted && referenceFillColor != null) {
    return referenceFillColor;
  }
  return fillColorByVariant(zoneType, variant, isSelected, disabled);
}

export const fillColorByVariant = (
  zoneType: number,
  variant: ZoneVariant | undefined,
  isSelected: boolean,
  disabled?: boolean
): number => {
  const selectedColor = 0x0000ff;
  const disabledColor = 0x5e5e5e;
  const occupiedColor = 0xff0000;
  const forbiddenColor = 0xd2dae1;
  const tempColor = 0xdddd56;

  if (isSelected) return selectedColor;
  if (disabled) return disabledColor;
  if (!variant) return colorPerType(zoneType);

  switch (variant) {
    case ZoneVariant.AVAILABLE:
      return colorPerType(zoneType);
    case ZoneVariant.OCCUPIED:
      return occupiedColor;
    case ZoneVariant.DISABLED:
      return disabledColor;
    case ZoneVariant.FORBIDDEN:
      return forbiddenColor;
    case ZoneVariant.TEMP:
      return tempColor;
    default:
      return colorPerType(zoneType);
  }
};
